// Third Party Library
import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Tabs } from "antd";

// Constants Library
import { TEMPLATE } from "../../constants";

// Components Library
import { BtnSubmit, TableList } from "../../components";
import { CreateCompany } from "./components";

// Handler Library
import { exportHDLR, tableHDLR } from "../../handlers";

// Services Library
import { TIME, REDUX as REDUX_UTIL } from "../../services/util";

// Styles Library
import styles from "../../pages/index.module.css";

// Redux Actions
import * as REDUX_ACTION from "../../services/redux/actions";
import { TableItems } from "./components/TableCompany/items";

const { reduxStoreWrapper } = REDUX_UTIL;
const { parseExportTime } = TIME;
const { BTN_IMG } = TEMPLATE.BTN;
const { selectOptions } = TEMPLATE.COMPANY;
const { COMPANY_SUMMARY_COL } = TEMPLATE.TABLEDATA.COMPANY;

const CompanyList = (props) => {
  const { col } = props;
  const dispatch = useDispatch();

  const companies = useSelector(reduxStoreWrapper("company.byID")) || {};
  const user = useSelector(reduxStoreWrapper("user"));

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState([]);
  const [tabKey, setTabKey] = useState("all");
  const [pageSize, setPageSize] = useState(10);
  const [current, setCurrent] = useState(1);
  const [paginatedData, setPaginatedData] = useState([]);
  const [company, setCompany] = useState([]);
  const [filteredData, setFilteredData] = useState([]);

  const statusText = {
    all: "all",
    active: 1,
    inactive: 2,
    terminated: 0,
  };

    useEffect(() => {
      dispatch(REDUX_ACTION.v1_company.get_all_company_request());
      dispatch(REDUX_ACTION.v1_employer.get_all_employer_request());
      dispatch(REDUX_ACTION.v1_employer.get_employer_list_no_coid_request());
      dispatch(REDUX_ACTION.v1_loyalty.get_all_loyalty_request());
      dispatch(REDUX_ACTION.v1_privilege.get_all_privilege_request());
      return () => {};
    }, [dispatch]);

  useEffect(() => {
    const updatedCompany = Object.values(companies).map((t) => ({
      ...t,
      key: t.coid,
      status: t.status ?? 1,
      picName: t.pic?.name
    }));
    setCompany(updatedCompany);
  }, [companies]);

  useEffect(() => {
    if (company.length > 0)
      setFilteredData(tableHDLR.dataTableSorting(company));
  }, [company]);

  const exportData = selectedRow.length > 0 ? selectedRow : filteredData;
  const template = COMPANY_SUMMARY_COL({
    redux: {
      user,
    },
    exportState: true,
  });

  const exportButton = (
    <BtnSubmit
      display="inline-block"
      text="Export"
      bgColor="transparent"
      color="#4CAF50"
      padding="9px 18px"
      onClick={() =>
        exportHDLR.exportWithTemplate({
          data: exportData,
          filename: `CompanySummary_${parseExportTime()}`,
          template: template,
        })
      }
      showIcon={true}
      icon={BTN_IMG.EXPORT}
      icon_alt={"export"}
    />
  );

  const filteredDataCount = tableHDLR.dataCount(statusText, filteredData);

  useEffect(() => {
    if (filteredData.length) {
      const startIndex = (current - 1) * pageSize;
      const endIndex = startIndex + pageSize;
      const newData = tableHDLR.datasourceFilter(filteredData, tabKey) ?? []
      const slicedData = newData.slice(startIndex, endIndex);
      setPaginatedData(slicedData);
    }
  }, [current, pageSize, filteredData, tabKey]);

  const handlePageChange = (page) => {
    const sorted = tableHDLR.dataTableSorting(page)
    setPaginatedData(sorted);
  };

  const handleTab = (key) => {
    setTabKey(key);
    setCurrent(1);
  };

  return (
    <>
      <div className={styles.container} style={{ width: col ? "80vw" : "73vw" }}>
        <TableList.FilterData
          isModalOpen={isModalOpen}
          setIsModalOpen={() => setIsModalOpen(false)}
          selectOptions={selectOptions}
          filteredData={tableHDLR.datasourceFilter(company, tabKey)}
          setFilteredData={setFilteredData}
          tabKey={tabKey}
          statusText={statusText}
        />
        <CreateCompany
          isModalOpen={isModalOpen}
          setIsModalOpen={setIsModalOpen}
          pageSize={pageSize}
          setPageSize={setPageSize}
          tabKey={tabKey}
          current={current}
          setCurrent={setCurrent}
          handlePaginatedDataChange={handlePageChange}
          filteredDataCount={filteredDataCount}
          data={filteredData}
        />
        <div style={{ marginTop: "3.5em" }}>
          <Tabs
            tabBarExtraContent={exportButton}
            onTabClick={handleTab}
            items={TableItems(
              filteredDataCount,
              company,
              filteredData, 
              paginatedData,
              tabKey,
              setFilteredData,
              selectedRow,
              setSelectedRow
            )}
          />
        </div>
      </div>
    </>
  );
};

export default CompanyList;
